import { useMatch } from "react-router-dom";

/**
 * This hook returns true if the user is currently in the onboarding flow.
 *
 * @returns boolean
 */
export const useIsOnboarding: () => boolean = () => !!useMatch("/onboarding/*");
